import { JOB_TYPE } from '../jobs.model';

export const getJobApiPrefix = (jobType: JOB_TYPE.INFERENCE | JOB_TYPE.TRAINING): string =>
  jobType === JOB_TYPE.INFERENCE ? 'inference-jobs' : 'training-jobs';
